import { differenceInHours, format, isBefore } from 'date-fns';
import { z } from 'zod';

import { createUTCDate } from '@/helpers/datetime/utc-date';

export const CancelShutdownFormSchema = z.object({
  cancelShutdownReason: z
    .string({
      required_error: 'A reason is required.',
    })
    .min(1, { message: 'A reason is required.' })
    .max(500, { message: 'Reason must be less than 500 characters' }),
});

export const ExtendShutdownFormSchema = z
  .object({
    extendShutdownDateTime: z.date({
      required_error: 'A date is required.',
    }),
    restartDateTime: z.date().optional().nullable(),
  })
  .superRefine((data, ctx) => {
    // Convert to UTC date for comparison
    const now = createUTCDate();
    const adjustedDateTime = createUTCDate(data.extendShutdownDateTime);
    if (isBefore(adjustedDateTime, now)) {
      ctx.addIssue({
        code: z.ZodIssueCode.invalid_date,
        message: 'Restart date and time must be in the future.',
        path: ['extendShutdownDateTime'],
      });
    }

    const diff = differenceInHours(adjustedDateTime, now);
    if (diff > 72) {
      ctx.addIssue({
        code: z.ZodIssueCode.invalid_date,
        message: 'Cannot extend shutdown by more than 72 hours.',
        path: ['extendShutdownDateTime'],
      });
    }
    if (data.restartDateTime) {
      if (
        isBefore(createUTCDate(data.extendShutdownDateTime), createUTCDate(data.restartDateTime))
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.invalid_date,
          message:
            'Restart date and time must be after ' +
            format(data.restartDateTime, "EEEE, MMMM d 'at' h:mm a"),
          path: ['extendShutdownDateTime'],
        });
      }
    }
  });

export type CancelShutdownFormData = z.infer<typeof CancelShutdownFormSchema>;

export type ExtendShutdownFormData = z.infer<typeof ExtendShutdownFormSchema>;
